import React, { useEffect, createElement } from 'react';
import { SalesPage } from './pages/SalesPage';
import { CurrencyProvider } from './hooks/useCurrency';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Inject Meta Pixel script
    if (!window.fbq) {
      const n: any = window.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    window.fbq('init', '1841883482976444');
    window.fbq('track', 'PageView');
    window.fbq('track', 'ViewContent', {
      content_name: 'Soft Hold',
      content_type: 'product',
      value: 14,
      currency: 'USD'
    });
  }, []);
  return <CurrencyProvider data-id="element-0">
      <SalesPage data-id="element-1" />
    </CurrencyProvider>;
}